export function loadScript(url: string, timeout = 5000): Promise<void> {
  const script = document.createElement('script')
  script.src = url
  document.head.appendChild(script)

  let timeoutHandle: number;

  const loadingPromise = new Promise<void>((resolve, reject) => {
    script.addEventListener('load', () => {
      window.clearTimeout(timeoutHandle)
      resolve()
    })
    script.addEventListener('error', () => {
      window.clearTimeout(timeoutHandle)
      reject(`Script ${url} failed to load`)
    })
  })

  const timeoutPromise = new Promise<void>((_resolve, reject) => {
    timeoutHandle = window.setTimeout(() => {
      reject(`Script ${url} failed to load within ${timeout}ms`)
    }, timeout)
  })

  return Promise.race([loadingPromise, timeoutPromise])
}
